import { __ } from '@99designs/i18n';
import usePricingContextIfProvided from './usePricingContextIfProvided';

const MARKETS_WITHOUT_VAT_MESSAGE = ['in', 'au', 'sg', 'nz', 'us', 'ca'];

export default function useVatMessaging(bottomBarVersion = false) {
    const pricingContext = usePricingContextIfProvided();

    const hasVatMessage =
        pricingContext?.market &&
        !MARKETS_WITHOUT_VAT_MESSAGE.includes(pricingContext?.market?.toLowerCase() || '');
    if (!hasVatMessage) {
        return null;
    }

    const prefix = bottomBarVersion ? '' : ' (';
    const suffix = bottomBarVersion ? '' : ')';

    const vatInc = bottomBarVersion
        ? __('Inc. VAT', {
              _context:
                  'Indicates that the price includes VAT, with the word "includes" shortened in a way that is most natural to the language.',
          })
        : __('inc. VAT', {
              _context:
                  'Short tax message displayed next to the VAT-inclusive price of a design service product.',
          });
    const vatEx = bottomBarVersion
        ? __('Excl. VAT', {
              _context:
                  'Indicates that the price excludes VAT, with the word "excludes" shortened in a way that is most natural to the language.',
          })
        : __('ex. VAT', {
              _context:
                  'Short tax message displayed next to the VAT-exclusive price of a design service product.',
          });

    return pricingContext?.vatInclusive
        ? `${prefix}${vatInc}${suffix}`
        : `${prefix}${vatEx}${suffix}`;
}
